import { Component, OnInit, Input, OnChanges, SimpleChanges,
  ChangeDetectorRef, EventEmitter, Output, ViewChildren, QueryList, OnDestroy, ElementRef, ViewChild, 
  AfterViewInit} from '@angular/core';
import { CurrencyPipe, DatePipe, DecimalPipe } from '@angular/common';
import { NbToastrService, NbDialogService, NbPopoverDirective } from '@nebular/theme';
import { Subscription } from 'rxjs';
import { ApiService } from '../../../../@core/service/api.service';
import { CompilationModel, DeductibleItem, EPackingStatus } from '../../../../@models/erp/compilation';
import { VatPercentData, Currency, UnitData, CompilationTypeData,
  DocConfig, InvoicePaymentData, IssuerData, SpoStatusData, TransportStatusData, DateSelectionData, DocumentStatusData, 
  AvailabilityStatusData,
  CountryCodes}
  from '../../../../@models/erp/compilationData';
import { AssociatedPfspo, IRelatedOC, LineItemModel, LineItemPosition } from '../../../../@models/erp/lineItem';
import { CommonDialogComponent, NrkDialogButton, NrkDialogType } from '../../shared/common-dialog/common-dialog.component';
import { DocMetrics } from './line-item-metrics/line-item-metrics.component';
import { EAccountingType, EPriceType, PriceItem } from '../../../../@models/erp/priceMatrix';
import * as uniqid from 'uniqid';
import { EProductType, FinishedProductModel, NameTable } from '../../../../@models/erp/finishedProduct';
import { BaseProductModel } from '../../../../@models/erp/baseProduct';
import { StringToNumberPipe } from '../../../../@theme/pipes/string-to-number.pipe';
import { IDocumentTree, TreeService } from '../../../../@core/service/tree.service';
import { getDocumentNumber, isEmpty, mongoId, round, stableSort } from '../../../../@core/common/global';
import { SharedDataService } from '../../../../@core/service/shared-data.service';
import { LineItemInfoBoxComponent } from './line-item-info-box/line-item-info-box.component';
import { BarcodesComponent } from '../barcodes/barcodes.component';
import { SelectorDisplayMode } from '../document-select/document-select.component';
import { ItemsList } from '@ng-select/ng-select/lib/items-list';
import { RoundPipe } from '../../../../@theme/pipes';
import { EventService } from '../../../../@core/service/eventService';
import { BoxStatus, CaseDetails, EBoxStatus, SpoBoxModel } from '../../../../@models/erp/spoBox';
import { ICheckboxChangeWithEvent } from '../../shared/doc-form-checkbox/doc-form-checkbox.component';
import { NrkWindowComponent } from '../../shared/nrk-window/nrk-window.component';
import * as moment from 'moment';
import { DocumentComponent } from '../document.component';
import { BoxSelectionComponent } from './box-selection/box-selection.component';
import { PaymentPlanInvoicesComponent } from '../payment-plan/payment-plan-invoices/payment-plan-invoices.component';
import { matrix } from 'echarts';


@Component({
  selector: 'ngx-line-item-container',
  templateUrl: './line-item-container.component.html',
  styleUrls: ['./line-item-container.component.scss'],
})
export class LineItemContainerComponent implements OnChanges, OnInit, OnDestroy, AfterViewInit {
  @Input() compilation: CompilationModel;
  @Input() documentComponent: DocumentComponent;
  @Input() priceDate: Date;
  // @Input() businesses: BusinessModel[];
  // @Input() finishedProductNames: NameTable[];
  @Input() disabled: boolean = false;
  @Input() baseProducts: BaseProductModel[];
  @Input() optional = false;
  @Output() copyToClipboard: EventEmitter<string> = new EventEmitter<string>();
  @Output() lineItemsChanged: EventEmitter<any> = new EventEmitter<any>();
  @ViewChildren(NbPopoverDirective) popovers: QueryList<NbPopoverDirective>;
  @ViewChildren('infoBox') infoBoxes: QueryList<LineItemInfoBoxComponent>;
  @ViewChild('boxesWindow') boxesWindow: NrkWindowComponent;
  @ViewChild('boxSelection') boxSelection: BoxSelectionComponent;
  @ViewChild('ppInv') ppInv: PaymentPlanInvoicesComponent;
  hidePopovers = () => this.popovers && this.popovers.forEach(el => el.hide());

  subscriptions = [];

  lineItems: LineItemModel[];
  deductibleItems: DeductibleItem[];
  vatItems: { vat: number, sum: number, partialVat: number, discountedVat: number }[];

  lineItemSubscription: Subscription;
  finishedProductSubscription: Subscription;

  vatPercentOptions = VatPercentData.getOptions();
  currencyOptions = Currency.getOptions();

  baseProductOptions: { id: string, name: string }[];
  invoicePercentStyle = { width: '4em' };

  // businessUnitOptions: any;
  orderLineItems: LineItemModel[];
  partialDeliveryCalced = false;
  associatedOCPfspos: { oc: CompilationModel, ocli: LineItemModel, ocpos: number, spo: AssociatedPfspo }[][]; // for Order overview
  storedPartialDelivery: { num: 0, sum: 0 }

  showWizard = false;

  index = 0;

  selectorDisplayMode = SelectorDisplayMode;
  unitData = UnitData;
  spoStatusData = SpoStatusData;
  transportStatusData = TransportStatusData;
  typeData = CompilationTypeData;
  mongoId = mongoId;
  Object = Object;

  docConfig = DocConfig;
  countryOptions = CountryCodes.getOptions();

  associatedCS = [];

  netTotal = 0;
  partialNetTotal = 0;
  discountedNetTotal = 0;
  subTotal = 0;
  partialSubTotal = 0;
  discountedSubTotal = 0;
  vatTotal = 0;
  partialVatTotal = 0;
  discountedVatTotal = 0;
  sumTotal = 0;
  partialSumTotal = 0;
  discountedSumTotal = 0;

  totalQuantity = {
    pc: 0,
    m2: 0,
    m: 0,
    kg: 0,
  }

  obicNum = 0;
  obicSum = 0;

  deductibleTotal = 0;
  ppInvoicesTotal = 0;

  ppNetTotal = 0;
  ppPartialNetTotal = 0;
  ppDiscountedNetTotal = 0;


  calculatedSubTotal = 0;
  calculatedTotal = 0;

  issuer: string;

  lineItemsLoaded = false;

  clipboardList: string[][] = [];
  clipboardFullList: { oc: string, dn: string } = { oc: '', dn: '' };

  calcPalletQty: number[] = [];

  itemPrice: PriceItem[] = [];

  // deductibleInvoiceData = { treeInvoices: [], invoices: [] };

  spoBoxes: { [type: number]: { [type: string]: SpoBoxModel[] }} = [];
  expiryData: { [type: number]: { [type: string]: any }} = [];

  removeItemEnabled = true;

  boxBlockValues = [];

  obicCodes = [];

  viewReady = false;

  invalidPriceItems = [];

  paymentPlanHasInvoices = false;

  assignedPfsposConfig = [
    { id: 'spoCode', name: '(PF)SPO # / CS #' },
    { id: 'spoPos', name: 'Pos' },
    { id: 'directDelivery', name: 'Shipment' },
    { id: 'spoQ', name: 'Q' },
    { id: 'unit', name: 'Unit' },
    { id: 'quantity', name: 'Q/pc'},
    { id: 'exwArrival', name: 'EXW & Arrival' },
    // { id: 'arrivingVieDate', name: 'VIE arrival' },
    // { id: 'dispatchDelivery', name: 'Disp. & Delivery' },
    { id: 'dispatchEta', name: 'Dispatch & ETA Cust.' },
    { id: 'spoStatus', name: '(PF)SPO status' },
    { id: 'transportStatus', name: 'Transp. status' },
    { id: 'planned Q', name: 'Ass.Q' },
  ]
  assignedOCPfsposConfig = [
    { id: 'ocCode', name: 'OC #' },
    { id: 'ocPos', name: 'OC Pos' },
    ...this.assignedPfsposConfig,
  ]

  generatingFinishedProducts = false;

  constructor(
    private api: ApiService,
    public data: SharedDataService,
    private toastrService: NbToastrService,
    private cdRef: ChangeDetectorRef,
    private dialogService: NbDialogService,
    private decimalPipe: DecimalPipe,
    private datePipe: DatePipe,
    private roundPipe: RoundPipe,
    public tree: TreeService,
    public event: EventService,
  ) {
  }

  ngAfterViewInit(): void {

    this.viewReady = true;

  }

  // ngDoCheck(): void {
  //   this.lineItems = this.optional ? this.compilation.optionalLineItems : this.compilation.lineItems;
  // }

  async ngOnInit() {
    // this.init();
    this.issuer = IssuerData.get(this.compilation.issuer).name.toLowerCase();
    // if (!this.businessUnitOptions) {
    //   const buo = this.api.reloadBusinessUnits().subscribe(_bu => {
    //     this.businessUnitOptions = _bu.map(m => ({ id: m._id, name: m.name }));
    //     buo.unsubscribe();
    //   });
    // }

    await Promise.all(this.lineItems.map((li, idx) => this.boxBlockValues[idx] = {}));
    this.subscriptions.push(this.event.preSaveCompilation.subscribe(success => this.onSave(success)));
    this.subscriptions.push(this.tree.documentTreeLoadedEvent.subscribe((tree: IDocumentTree) => this.onDocumentTreeLoaded(tree)));
  }

  

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  async ngOnChanges(changes: SimpleChanges) {
    // console.log('line items changes', changes, this.boxBlockLines);
    if (changes.compilation && changes.compilation.currentValue) {
      this.paymentPlanHasInvoices = !isEmpty(this.compilation.paymentPlan?.items?.some(f => f.invoices?.length > 0));
      this.init();
      this.recalc();
      this.recalcQuantities();
      this.populateOrderLineItems(this.compilation);
    }

    if (changes.disabled && ['PL', 'DN'].includes(CompilationTypeData.get(this.compilation.type).code)) {
      this.disabled = true;
      this.removeItemEnabled = true;
    } else {
      this.removeItemEnabled = false;
    }

    this.compilation.lineItems.forEach((li, idx) => {
      if (!li.finishedProduct?._id) li.finishedProduct = this.data.finishedProducts.find(f => mongoId(f) === mongoId(li.finishedProduct))
      // don't do optional chaining
      if (li.finishedProduct && li.finishedProduct.showMissingCpsWarning === undefined && li.finishedProduct.type === EProductType.Energy ) {
        li.finishedProduct.showMissingCpsWarning = true;
      }

      li.pfspo?.forEach(async (el) => this.associatedCS[el.code] = await this.api.findCombinedShipment(el.code));
      // li.pfspo?.forEach(async (el) => el.doc = await this.api.loadCompilationByCode(el.code));

      // console.log('-------------->', li.pfspo?.[0].doc?.directDelivery, li.pfspo, this.tree.linkedPfspos);

      if (!li.poVisibility) {
        if (li.posPDinPdf) {
          li.poVisibility = { poNum: true, poPos: true, poDelivery: true };
        } else {
          li.poVisibility = { poNum: true, poPos: false, poDelivery: false };
        }
      }
      // console.log('===>onchanges', this.compilation.visibleFields);
      // li.tcChecked = this.compilation.visibleFields.includes('liTC' + li.position?.internalPos);

      // this.boxBlockValues[idx] = this.boxSelection.getBoxBlockValues(); // {};
    })
  }

  getClipboardLineData(doc: CompilationModel, lineItem: LineItemModel) {
    const isOC = doc.type === CompilationTypeData.get('OC').id && this.tree.linkedOC;
    const docnum = `${doc.code}VS${doc.version}`;
    const exwDate = ((isOC ? doc.exwJapanDate : this.tree.linkedCS?.exwJapanDate || this.tree.linkedOC?.exwJapanDate) as any)?.replace(/T.*/, '') || '';
    const etaDate = ((isOC ? doc.etaCustomerDate : this.tree.linkedOC?.etaCustomerDate) as any)?.replace(/T.*/, '') || '';
    const arrivingDate = ((isOC ? doc.arrivingVieDate : this.tree.linkedCS?.arrivingVieDate || this.tree.linkedOC?.arrivingVieDate) as any)?.replace(/T.*/, '') || '';
    const dispatchDate = ((isOC ? doc.vieDispatchDate : this.tree.linkedOC?.vieDispatchDate) as any)?.replace(/T.*/, '') || '';
    const customerRef = this.data.businesses?.find(f => mongoId(f) === mongoId(doc.customerReference)) || '';
    const customerName = customerRef ? (customerRef?.name) : '';
    const customerCode = doc.customerDocumentNumber || '';
    const method = doc.meansOfTransport || '';
    const fp = this.data.finishedProducts.find(f => mongoId(f) === mongoId(lineItem.finishedProduct));
    const obic = lineItem.tbCode ? lineItem.tbCode + '\n' : '';
    const popos = lineItem.position?.orderPos === -2 ? 'detached' : this.tree.getItemOrderPos(lineItem);

    return { docnum, exwDate, etaDate, arrivingDate, dispatchDate, customerRef, customerName, customerCode, method, fp, obic, popos }
    // this.compilation.lineItems.forEach((li, idx) => {
    //   const fp = this.data.finishedProducts.find(f => mongoId(f) === mongoId(li.finishedProduct));
    //   const obic = li.tbCode ? li.tbCode + '\n' : '';
    //   const popos = li.position?.orderPos === -2 ? 'detached' : li.position.orderPos;
    //   if (['PFSPO', 'SPO'].includes(CompilationTypeData.get(this.compilation.type).code)) {
    //     this.clipboardList.push([
    //       `${docnum}\n${obic}Pos ${idx+1} - ${fp?.calcCode} - ${fp?.calcName} - ${li?.quantity} pcs\nEXW: ${exwDate} - ARR VIE: ${arrivingDate}`
    //     ]);
    //   } else if (['OC', 'PL', 'DN'].includes(CompilationTypeData.get(this.compilation.type)?.code)) {
    //     console.log('sync clipboard finished product', fp);
    //     this.clipboardList.push([
    //       `${docnum}\nDispatch date NRKA: ${dispatchDate} - Expected ETA date: ${etaDate}\nPos ${idx+1} - ${customerName} - ${customerCode} - POPos ${popos} - PD ${li.partialDelivery?.num || 1}/${li.partialDelivery?.sum || 1} - ${fp?.calcCode} - ${fp?.calcName} - ${li.quantity} pcs`
    //     ]);
    //   } else if (['IN', 'PFIN'].includes(CompilationTypeData.get(this.compilation.type)?.code)) {
    //     const docs = this.tree.findDocsByDownstreamType(this.compilation)
    //     this.clipboardList.push([
    //       `${docnum}\nDispatch date NRKA: ${dispatchDate} - Expected ETA date: ${etaDate}\nPos ${idx+1} - ${customerName} - ${customerCode} - POPos ${popos} - PD ${li.partialDelivery?.num || 1}/${li.partialDelivery?.sum || 1} - ${fp?.calcCode} - ${fp?.calcName} - ${li.quantity} pcs`
    //     ]);
    //   }
    // })
  }

  syncClipboardList() {
    let d = null;
    this.compilation.lineItems.forEach((li, idx) => {

      if (['PFSPO', 'SPO'].includes(CompilationTypeData.get(this.compilation.type).code)) {
        const d = this.getClipboardLineData(this.compilation, li);
        this.clipboardList.push([
          `${d.docnum.replace(/VS.*/, '')}\n${d.customerCode ?? ''} Pos ${idx+1} - ${d.fp?.calcCode ?? ''} - ${d.fp?.calcName ?? ''} - ${li?.attributeCode ?? ''} - ${li?.quantity ?? '0'} pcs\nEXW: ${d.exwDate ?? 'n/a'} - ETA AT: ${d.arrivingDate ?? 'n/a'} - Method: ${d.method ?? 'n/a'}`
        ]);
      } 
      else if (['OC', 'PL', 'DN', 'IN', 'PFIN'].includes(CompilationTypeData.get(this.compilation.type)?.code)) {
        let docs = [this.compilation];
        if (['IN', 'PFIN'].includes(CompilationTypeData.get(this.compilation.type)?.code)) {
          docs = this.tree.findDocsByUpstreamType(this.compilation, 'OC')
        }

        this.clipboardList.push(docs.map(m => this.getClipboardLineData(m, li)).map(d => {
          const tail = `PD ${li.partialDelivery?.num || 1}/${li.partialDelivery?.sum || 1} - ${d.fp?.calcCode ?? ''} - ${d.fp?.calcName ?? ''} - ${li.attributeCode ?? ''} - ${li.quantity ?? 0} pcs - ${Math.round(li.displayUnitQuantity)} ${this.unitData.get(li.displayUnit)?.short}`;
          if (['OC'].includes(CompilationTypeData.get(this.compilation.type)?.code)) {
            return `${d.docnum}\nETA: ${d.etaDate ?? 'n/a'} (+/-2)\n${d.customerName ?? ''} - ${d.customerCode ?? ''} - Pos ${this.tree.getItemOrderPos(li)} - ${tail}`;
          } else if (['PL', 'DN'].includes(CompilationTypeData.get(this.compilation.type)?.code)) {
            // return `${d.docnum}\nDispatch: ${d.dispatchDate ?? 'n/a'} - ETA: ${d.etaDate ?? 'n/a'} - ${d.customerName ?? ''} - ${d.customerCode ?? ''}\nPOPos ${d.popos} - ${tail}`;
            return `${d.docnum}\nDate of Dispatch: ${d.dispatchDate ?? 'n/a'}\nETA: ${d.etaDate ?? 'n/a'} (+/-2)\n${d.customerName ?? ''} - ${d.customerCode ?? ''} - Pos ${d.popos} - ${tail}`;
          } else {
            return `${d.docnum}\nDispatch date NRKA: ${d.dispatchDate ?? 'n/a'} - Expected ETA date: ${d.etaDate ?? 'n/a'}\nPos ${idx+1} - ${d.customerName ?? ''} - ${d.customerCode ?? ''} - POPos ${d.popos} - ${tail}`;
          }
        }));

      }

      let data = this.getClipboardLineData(this.compilation, this.compilation.lineItems[0]);

      this.clipboardFullList.oc = `${data.docnum}\nETA: ${data.etaDate ?? 'n/a'} (+/-2)\n` + this.compilation.lineItems.map(li => {
        const d = this.getClipboardLineData(this.compilation, li);
        const tail = `PD ${li.partialDelivery?.num || 1}/${li.partialDelivery?.sum || 1} - ${d.fp?.calcCode ?? ''} - ${d.fp?.calcName ?? ''} - ${li.attributeCode ?? ''} - ${li.quantity ?? 0} pcs - ${Math.round(li.displayUnitQuantity)} ${this.unitData.get(li.displayUnit)?.short}`;
        return `${d.customerName ?? ''} - ${d.customerCode ?? ''} - Pos ${this.tree.getItemOrderPos(li)} - ${tail}`
      }).join('\n');

      this.clipboardFullList.dn = `${data.docnum}\nDate of Dispatch: ${data.dispatchDate ?? 'n/a'}\nETA: ${data.etaDate ?? 'n/a'} (+/-2)\n` + this.compilation.lineItems.map(li => {
        const d = this.getClipboardLineData(this.compilation, li);
        const tail = `PD ${li.partialDelivery?.num || 1}/${li.partialDelivery?.sum || 1} - ${d.fp?.calcCode ?? ''} - ${d.fp?.calcName ?? ''} - ${li.attributeCode ?? ''} - ${li.quantity ?? 0} pcs - ${Math.round(li.displayUnitQuantity)} ${this.unitData.get(li.displayUnit)?.short}`;
        return `${d.customerName ?? ''} - ${d.customerCode ?? ''} - Pos ${d.popos} - ${tail}`
      }).join('\n');

    })

    // const docnum = `${this.compilation.code}VS${this.compilation.version}`;
    // const exwDate = (this.compilation.exwJapanDate as any)?.replace(/T.*/, '') || '';
    // const etaDate = (this.compilation.etaCustomerDate as any)?.replace(/T.*/, '') || '';
    // const arrivingDate = (this.compilation.arrivingVieDate as any)?.replace(/T.*/, '') || '';
    // const dispatchDate = (this.compilation.vieDispatchDate as any)?.replace(/T.*/, '') || '';
    // const customerRef = this.data.businesses?.find(f => mongoId(f) === mongoId(this.compilation.customerReference));
    // const customerName = (customerRef?.name) || '';
    // const customerCode = this.compilation.customerDocumentNumber || '';
    // this.compilation.lineItems.forEach((li, idx) => {
    //   const fp = this.data.finishedProducts.find(f => mongoId(f) === mongoId(li.finishedProduct));
    //   const obic = li.tbCode ? li.tbCode + '\n' : '';
    //   const popos = li.position?.orderPos === -2 ? 'detached' : li.position.orderPos;
    //   if (['PFSPO', 'SPO'].includes(CompilationTypeData.get(this.compilation.type).code)) {
    //     this.clipboardList.push([
    //       `${docnum}\n${obic}Pos ${idx+1} - ${fp?.calcCode} - ${fp?.calcName} - ${li?.quantity} pcs\nEXW: ${exwDate} - ARR VIE: ${arrivingDate}`
    //     ]);
    //   } else if (['OC', 'PL', 'DN'].includes(CompilationTypeData.get(this.compilation.type)?.code)) {
    //     console.log('sync clipboard finished product', fp);
    //     this.clipboardList.push([
    //       `${docnum}\nDispatch date NRKA: ${dispatchDate} - Expected ETA date: ${etaDate}\nPos ${idx+1} - ${customerName} - ${customerCode} - POPos ${popos} - PD ${li.partialDelivery?.num || 1}/${li.partialDelivery?.sum || 1} - ${fp?.calcCode} - ${fp?.calcName} - ${li.quantity} pcs`
    //     ]);
    //   } else if (['IN', 'PFIN'].includes(CompilationTypeData.get(this.compilation.type)?.code)) {
    //     const docs = this.tree.findDocsByDownstreamType(this.compilation)
    //     this.clipboardList.push([
    //       `${docnum}\nDispatch date NRKA: ${dispatchDate} - Expected ETA date: ${etaDate}\nPos ${idx+1} - ${customerName} - ${customerCode} - POPos ${popos} - PD ${li.partialDelivery?.num || 1}/${li.partialDelivery?.sum || 1} - ${fp?.calcCode} - ${fp?.calcName} - ${li.quantity} pcs`
    //     ]);
    //   }
    // })
  }

  expiryClipboardText(idx: number, expiryData: any, spo: AssociatedPfspo, copyToClipboard = false) {
    const oldestDate = this.data.date(expiryData[idx][spo.code]?.oldestProductionDate) || '';
    const newestDate = this.data.date(expiryData[idx][spo.code]?.newestProductionDate) || '';
    const problem = expiryData[idx][spo.code]?.warningText || '';
    const text = `${this.compilation.code || ''} - ${this.data.getBusinessName(this.compilation.recipient) || ''
      } - ${this.compilation.customerDocumentNumber || ''} - ${this.lineItems[idx]?.finishedProduct?.calcCode || ''
      } - ${this.lineItems[idx]?.finishedProduct?.calcName || ''} - ${spo.code || ''
      } - ${oldestDate} - ${newestDate} - ${this.data.date(this.compilation.vieDispatchDate) || ''} - ${problem}`

    if (copyToClipboard) this.data.copyToClipboard(text);
    return text;
  }

  setBoxBlockLines(bpl: {idx: number, lines: any}) {
    // this.boxBlockValues[bpl.idx] = bpl.lines;
    if (bpl?.lines?.length) {
      Object.keys(bpl.lines[0]).forEach(key => {
        this.boxBlockValues[bpl.idx][key] = bpl.lines.map(m => m[key]).join('\n') || '';
      })
    }
    // console.log('set box block lines', bpl, this.boxBlockValues);
    this.cdRef.detectChanges();
  }

  // getBoxBlockValues(field: string, idx: number) {
  //   // console.log('getBoxBlockValues', field, idx, this.boxBlockValues[idx])
  //   // return this.boxBlockValues[idx]?.map(m => m[field]).join('\n') || 'N/A';
  //   return '';
  // }

  getObicCodes(item: LineItemModel) {
    const spoLineItems = item.pfspo.map(m => this.tree.linkedPfspos?.find(f => f.code === m.code)?.lineItems?.[m.pos-1]);
    // console.log('spoLineItems', item.pfspo, spoLineItems, this.tree.linkedPfspos);
    const obics = Array.from(new Set( spoLineItems.map(m => m?.tbCode )));
    // console.log('==> obics', obics, item.tbCode, item);
    return obics ? obics.filter(notNull => notNull)?.join(', ') : item.tbCode || '';
  }

  onClipboardList(text: string) {
    this.copyToClipboard.emit(text);
  }

  onORMail(lidx: number) {
    const content = this.data.compilationData.staticTexts.find(f => f.id === 'orMailText')?.data[0].replace(/\n/g, '<br>');
    const recipient = this.data.businesses.find(f => mongoId(f) === mongoId(this.compilation.recipient));
    const responsible = this.data.contacts.find(f => mongoId(f) === mongoId(recipient?.manager))?.title;

    const lineItem = this.compilation.lineItems?.[0];

    const orHtml = content
      .replace(/<responsible-name>/, responsible)
      .replace(/<issue-date>/, moment(this.compilation.issueDate).format('YYYY-MM-DD'))
      .replace(/<customer-name>/, recipient.name)
      .replace(/<customer-doc>/, this.compilation.customerDocumentNumber)
      .replace(/<product-code>/, lineItem?.finishedProduct?.calcCode)
      .replace(/<product-name>/, lineItem?.finishedProduct?.calcName)
      .replace(/<customer-code>/, lineItem?.attributeCode)
      .replace(/<quantity-and-unit>/, `${lineItem?.displayUnitQuantity} ${UnitData.get(lineItem?.displayUnit).short}`)
      .replace(/<line-crdd>/, `${moment(lineItem?.dateOfDelivery).format('YYYY-MM-DD')}`)
    this.data.copyHtmlToClipboard(orHtml);
  }


  onOCMail(lidx: number) {

    const header = this.data.compilationData.staticTexts.find(f => f.id === 'ocMailHeader')?.data[0].replace(/\n/g, '<br>');
    const noSpo = this.data.compilationData.staticTexts.find(f => f.id === 'ocNoSpoText')?.data[0].replace(/\n/g, '<br>');
    const nonCompleted = this.data.compilationData.staticTexts.find(f => f.id === 'ocNonCompletedSpoText')?.data[0].replace(/\n/g, '<br>');
    const completed = this.data.compilationData.staticTexts.find(f => f.id === 'ocCompletedSpoText')?.data[0].replace(/\n/g, '<br>');
    const footer = this.data.compilationData.staticTexts.find(f => f.id === 'ocMailFooter')?.data[0].replace(/\n/g, '<br>');    
    const contact = this.compilation.recipientContact?.split('\n')?.[0];

    let html = `<p>${header}</p>`;
    html += `<p><b>Order Summary | Bestellübersicht</b></p>`;
    if (lidx === -1) {
      html += `<p>${this.clipboardFullList.oc.replace(/\n/g, '<br>')}</p>`;
    } else {
      html += `<p>${this.clipboardList[lidx].join('\n').replace(/\n/g, '<br>')}</p>`;
      if (!this.compilation.lineItems[lidx].pfspo.length && noSpo) html += `<p>${noSpo}</p>`;
    }
    // if (!this.compilation.lineItems.flatMap(f => f.pfspo)?.length || this.compilation.lineItems.flatMap(f => f.pfspo).find(f => f.doc?.transportRun?.spoStatus !== SpoStatusData.get('confirmed').id)) {
    //   html += `<p>${noSpo}</p>`
    // }
    console.log('spo status', this.compilation.lineItems.flatMap(f => f.pfspo).map(m => m.code + ' - ' + m.doc.transportRun.spoStatus));
    if (!this.compilation.lineItems.flatMap(f => f.pfspo)?.length && noSpo) {
      html += `<p>${noSpo}</p>`
    } else if (this.compilation.lineItems.flatMap(f => f.pfspo).find(f => f.doc?.transportRun?.transportStatus === TransportStatusData.get('completed').id && completed)) {
      html += `<p>${completed}</p>`
    } else if (nonCompleted) {
      html += `<p>${nonCompleted}</p>`
    }
    html += footer ? `<p>${footer}</p>` : '';
    this.data.copyHtmlToClipboard(
      html.replace(/<contact-name>/g, contact)
    );
  }

  onINMail() {
    const totalNet = this.isPartialPayment()
      ? this.partialSumTotal
      : this.isDiscount()
        ? this.discountedSumTotal
        : this.sumTotal
    // const value = new CurrencyPipe('de', 'EUR').transform(totalNet, this.compilation.currency, 'code', '1.2-2');
//     const html = `
// <p>Dear ,</p>
// <p>Please find our invoice ${this.compilation.code} for your order ${this.compilation.customerDocumentNumber} attached.</p>
// <p>Sehr geehrte/r ,</p>
// <p>Hiermit übersenden wir unsere Rechnung ${this.compilation.code} für Ihre Bestellung ${this.compilation.customerDocumentNumber} im Anhang.</p>
// <br>
// <p>Issue date: ${new Date(this.compilation.issueDate).toISOString().replace(/T.*/, '')}</p>
// <p>Due date: ${new Date(this.compilation.dueDate).toISOString().replace(/T.*/, '')}</p>
// <p>Total to be paid net: ${totalNet.toFixed(2)} ${this.compilation.currency}</p>
// `

      // <div *ngIf="item.id === 'spoMailHeader'">Placeholder: &lt;contact-name&gt;, &lt;product-name&gt;, &lt;customer-code&gt;, &lt;customer-name&gt;, &lt;doc-code&gt;</div>
      // <div *ngIf="item.id === 'spoMailHeader'">Placeholder: &lt;item-pos&gt;, &lt;product-dim&gt;, &lt;quantity-pcs&gt;, &lt;exw-date&gt;, &lt;eta-date&gt;, &lt;transport-method&gt;</div>
    
    const contactName = this.compilation.recipientContact;
    const contact = this.compilation.recipientContact?.split('\n')?.[0];

    const inHtml = this.data.compilationData.staticTexts
      .find(f => f.id === 'inMailText')?.data[0]
      .split('\n')
      .map(line => `<p>${line}</p>`)
      .join('')
      .replace(/<contact-name>/g, contact)
      .replace(/<invoice-number>/g, this.compilation.code)
      .replace(/<customer-doc>/g, this.compilation.customerDocumentNumber)
      .replace(/<issue-date>/g, new Date(this.compilation.issueDate).toISOString().replace(/T.*/, '')) 
      .replace(/<due-date>/g, new Date(this.compilation.dueDate).toISOString().replace(/T.*/, '')) 
      .replace(/<exw-date>/g, new Date(this.compilation.issueDate).toISOString().replace(/T.*/, '')) 
      .replace(/<eta-date>/g, new Date(this.compilation.dueDate).toISOString().replace(/T.*/, '')) 
      .replace(/<total-net>/g, `${totalNet.toFixed(2)} ${this.compilation.currency}`)

    this.data.copyHtmlToClipboard(inHtml);
  }

  onSPOMail(lidx: number) {

    const exwDate = this.datePipe.transform(this.tree.linkedCS?.exwJapanDate || this.compilation.exwJapanDate, 'yyyy-MM-dd') ?? '';
    const arrivalDate = this.datePipe.transform(this.tree.linkedCS?.arrivingVieDate || this.compilation.arrivingVieDate, 'yyyy-MM-dd') ?? '';
    const customer = this.data.getBusinessAddressName(this.compilation.customerReference);
    const header = this.data.compilationData.staticTexts.find(f => f.id === 'spoMailHeader')?.data[0];
    const footer = this.data.compilationData.staticTexts.find(f => f.id === 'spoMailFooter')?.data[0];
    const contact = this.compilation.recipientContact?.split('\n')?.[0];
    const productName = this.lineItems[0]?.finishedProduct?.calcName;
    const customerCode = this.lineItems[0]?.attributeCode;
    // const exwDateYear = exwDate.replace(/-.*/, '');

    console.log('spo mail', this.data.contacts, this.compilation.recipientContact, this.data.contacts.find(f => mongoId(f) === mongoId(this.compilation.recipientContact)))

    const lineItems = this.lineItems.map((m, idx) => `
${this.compilation.customerDocumentNumber} Pos ${this.compilation.customerPoPosition || idx + 1


} - ${m.finishedProduct?.calcCode} - ${m.finishedProduct?.calcName} - ${m.attributeCode} - ${m.quantity} pcs
EXW: ${exwDate} - ETA AT: ${arrivalDate} - Method: ${this.tree?.linkedCS?.meansOfTransport || this.compilation?.meansOfTransport}
`).join('\n');

    const text = `${header}\n\n${lineItems}\n\n${footer}` 
    this.data.copyToClipboard(text
      .replace(/<contact-name>/g, contact)
      .replace(/<product-name>/g, productName)
      .replace(/<customer-code>/g, customerCode)
      .replace(/<customer-name>/g, customer)
      .replace(/<doc-code>/g, this.compilation.code)
    );
  }

  copyPackingToClipboard(lidx: number, extended = false) {

    const header = this.data.compilationData.staticTexts.find(f => f.id === 'dnMailHeader')?.data[0].replace(/\n/g, '<br>');
    const footer = this.data.compilationData.staticTexts.find(f => f.id === 'dnMailFooter')?.data[0].replace(/\n/g, '<br>');    

    let html = ''
    if (extended) {
      html += '<p>' + header + '</p>';

      html += '<p><b>Delivery Address | Lieferanschrift</b></p>'
      html += `<p>${this.compilation.deliveryAddress?.replace(/\n/g, '<br>')}</p><br>`

      html += '<p><b>Delivery Note Summary | Lieferscheinübersicht</b></p>'
      if (lidx === -1) {
        html += `<p>${this.clipboardFullList.dn.replace(/\n/g, '<br>')}</p><br>`;
      } else {
        html += `<p>${this.clipboardList[lidx].join('\n\n').replace(/\n/g, '<br>')}</p>`
      }
    }

    if (lidx === -1) {
      this.compilation.lineItems.forEach((li, idx) => {
        html += this.data.packingComponent.getClipboardPackingHtml(idx);
        html += '<br><br>'
        html += this.data.packingComponent.getClipboardSummaryHtml(idx);  
        if (idx !== this.compilation.lineItems.length - 1) html += '<br><br>'
      }) 
    } else {
      html += this.data.packingComponent.getClipboardPackingHtml(lidx);
      html += '<br><br>'
      html += this.data.packingComponent.getClipboardSummaryHtml(lidx);  
    }

    html += `<br><br><b>Carrier / Tracking Number</b><br> ${this.tree?.linkedCS?.meansOfTransport || this.compilation.meansOfTransport}`
      + ` ${this.tree?.linkedCS?.trackingCode || this.compilation.trackingCode || 'N/A'}`

    if (extended) {
      html += '<br><br>'
      html += '<p>' + footer + '</p>';
    }
    html = html.replace(/Packing Information/g, '<b>Packing Details | Lieferumfang</b>');
    html = html.replace(/Pallet Summary/g, '<b>Pallet Summary | Palettenübersicht</b>')
    this.data.copyHtmlToClipboard(html);
  }

  syncPartialDelivery() {
    this.lineItems && this.lineItems.forEach(li => li.storedPartialDelivery = li.partialDelivery);
  }

  async init() {
    this.lineItemsLoaded = false;
    this.data.loadProducts();
    if (!this.compilation.optionalLineItems) this.compilation.optionalLineItems = [];
    this.lineItems = this.optional ? this.compilation.optionalLineItems : this.compilation.lineItems;
    this.deductibleItems = this.compilation.deductibleItems;

    this.lineItems.forEach(li => {
      if (li.posPDinPdf === undefined) {
        li.posPDinPdf = true;
      }
      if (li.showCustomerProductSpecification === undefined) {
        li.showCustomerProductSpecification = true;
      }
    })

    // const ocs = this.compilation.type === CompilationTypeData.get('PFSPO').id || this.compilation.type === CompilationTypeData.get('SPO').id
    //   && this.compilation._id && await this.api.getRelatedOcs(this.compilation.code);
    // this.lineItems?.forEach((el, idx) => {
    //   if (ocs && ocs.length) {
    //     el['relatedOcs'] = ocs.filter(f => (f.pos-1) === idx);
    //     el['relatedOcsSum'] = el['relatedOcs'].map(m => m.quantity).reduce((p, c) => p + c, 0);
    //   }
    //   if (!el.position) {
    //     el.position = new LineItemPosition();
    //     el.position.id = el.code || uniqid.time(); // TODO: remove legacy el.code
    //     el.position.internalPos = idx;
    //   }
    //   console.log('line items', el.pfspo, el, idx, el.matrixPriceItem, el.piecePrice, el.displayUnitPrice);
    // })
    this.reloadFinishedProducts().then(() => this.lineItemsLoaded = true);
    if (this.baseProducts) this.baseProductOptions = this.baseProducts.map(bp => ({ id: bp.code, name: bp.name }));

  }


  async populateOrderLineItems(doc: CompilationModel) {
    // populate finished products of order lineitems TODO: fill it in backend
    if (doc.type === 3) { // Order confirmation only
      this.orderLineItems = (this.tree.findDoc(doc.parent) || {} as any).lineItems;
      if (this.orderLineItems && this.orderLineItems.length) {
        this.orderLineItems.forEach( (el, idx) => {
          if (el.finishedProduct) {
            // TODO: fix versioning mischmasch _id <=> code
            el.finishedProduct = this.data.finishedProducts.find(f => mongoId(f) === mongoId(el.finishedProduct)); // await this.api.loadFinishedProductById(mongoId(el.finishedProduct))
            // el.finishedProduct = el.finishedProduct && this.data.finishedProducts.find(f => f.code === el.finishedProduct.code); // await this.api.loadFinishedProductByCode(el.finishedProduct.code)
          }
          if (!el.position) { // legacy
            el.position = new LineItemPosition();
            el.position.internalPos = idx;
          }
          
        })
      }
    }
    console.log('populateOrderLineItems', this.orderLineItems, this.tree.findDoc(doc.parent), this.tree.linkedOR)
  }

  async onSave(success) {
    await Promise.all(this.lineItems.map((li, idx) =>
      li.pfspo.map(spo =>
        this.spoBoxes[idx] && this.api.saveSpoBoxes(this.spoBoxes[idx][spo.code]) // ?.then(s => console.log('saved spo box', s))
      )
    ).flat())
  }
  
  async loadBoxes() {
    // console.log('loadBoxes init');
    // this.data.boxesAreLoading.push(true);
    // this.spoBoxes = [];
    // this.cdRef.detectChanges();
    // console.log('load boxes called', this.compilation.lineItems);
    let idx = -1;
    let legacyUpdateRequired = [];
    for (const li of this.compilation.lineItems) {
      this.spoBoxes[++idx] = {};
      this.expiryData[idx] = {};
      const pallets = this.compilation.packingConditions.filter(f => f.lineItemIdx === idx);
      const palletisedBoxes = pallets?.flatMap(pal => pal.items?.flatMap(item => item.boxes.map(m => ({ pal: pal.palId, box: m }))));

      const spos = ['PFSPO', 'SPO'].includes(CompilationTypeData.get(this.compilation.type).code) ? [this.compilation] : li.pfspo;

      // console.log('===========================>spos', spos);

      if (spos?.length) for (const spo of spos) {
        this.spoBoxes[idx][spo.code] = await this.api.loadSpoBoxes({ spo: spo.code });
        // console.log('==========================>loadBoxes', this.spoBoxes[idx][spo.code]?.map(m => `${m.case}(${m.boxId})`));

        // TODO: remove legacy check begin
        // reverse check spo boxes / palletised status
        this.spoBoxes[idx][spo.code]?.flat().forEach((box: SpoBoxModel) => {
          const palletId = palletisedBoxes.find(f => f.box === box.boxId)?.pal;
          // console.log('box', box, 'palletId', palletId, 'palletRef', box.palletRef, box.status > EBoxStatus.assignedSpo, box.status, palletisedBoxes);
          if (palletId && box.status < EBoxStatus.assignedPallet) {
            box.status = EBoxStatus.assignedPallet;
            box.palletRef = palletId;
            // console.log('loadBoxes push box 1', palletId, box.status, box);
            legacyUpdateRequired.push(box);
          } else if (!palletId && (box.palletRef || box.status > EBoxStatus.assignedSpo)) {
            box.status = EBoxStatus.assignedSpo;
            box.palletRef = null;
            // console.log('loadBoxes push box 2', palletId, box.status, box);
            legacyUpdateRequired.push(box);
          } else if (palletId && palletId !== box.palletRef) {
            box.palletRef = palletId;
            // console.log('loadBoxes push box 3', palletId, box.status, box);
            legacyUpdateRequired.push(box);
          }
        })
        // TODO: remove legacy check end

        this.expiryData[idx][spo.code] = this.getExpiryData(li, spo.code, idx);

        // console.log('expiry data', this.expiryData);

      }
      // this.data.boxesAreLoading.pop();
    }
    
    // console.log('loadBoxes legacyupdaterequired', legacyUpdateRequired?.length);
    // TODO: remove legacy check begin
    if (legacyUpdateRequired?.length) {
      // console.log('loadBoxes legacyupdaterequired', legacyUpdateRequired);
      await this.api.saveSpoBoxes(legacyUpdateRequired);
    }
    // TODO: remove legacy check end

    // console.log('spo boxes loaded', this.spoBoxes);

  }


  async onDocumentTreeLoaded(tree: IDocumentTree): Promise<void> {
    // console.log('line items: onDocumentTreeLoaded', this.lineItems.length, this.compilation.lineItems.length);
    // TODO: move to tree-service
    this.populateOrderLineItems(this.compilation);

    if (['FCOR', 'OR'].includes(CompilationTypeData.get(this.compilation.type).code)) {
      const ocs = this.tree.filterDocumentTree('OC', this.tree.docNode);
      this.associatedOCPfspos = [];
      this.lineItems.forEach((orli, idx) => {
        if (!this.associatedOCPfspos[idx]) this.associatedOCPfspos[idx] = [];
        ocs?.forEach(oc => {
          oc.lineItems.forEach((ocli, ocpos) => {
            if (
              ocli.position && orli.position && ocli.pfspo && ocli.pfspo.length
              && ocli.position.orderPos === orli.position.internalPos
            ) {
              const items = ocli.pfspo.map(spo => ({ oc, ocli, ocpos, spo }));
              this.associatedOCPfspos[idx].push(...items);
            }
          })
        })
      });
    }

    if (['DN'].includes(CompilationTypeData.get(this.compilation.type).code)) {
      this.lineItems.forEach((li, idx) => {
        // console.log('------------->', li.pfspo, this.tree.linkedPfspos);
        li.pfspo?.forEach(async (el) => el.doc = this.tree.linkedPfspos?.find(f => f.code === el.code));
      });
      // console.log('-------------->', li.pfspo?.[0].doc?.directDelivery, li.pfspo, this.tree.linkedPfspos);
    }

    // calc partial delivery
    this.calcPartialDelivery();

    // console.log('sync line items', this.tree.linkedOC.lineItems, this.lineItems, this.compilation.lineItems);

    this.lineItems.forEach(async (li, idx) => {
      if (!li.pfspo) li.pfspo = []; // legacy check
      if (!li.position) { // legacy check
        li.position = new LineItemPosition();
        li.position.id = uniqid.time();
        li.position.orderPos = -1;
        if (this.compilation.type === CompilationTypeData.get('OC').id && this.tree.linkedOC?.lineItems[idx]) {
          this.tree.linkedOC.lineItems[idx].position = li.position;
        }
      }

      if (['OBIC', 'PFSPO', 'SPO'].includes(CompilationTypeData.get(this.compilation.type).code) && this.tree.linkedObic) { // only one line item allowed
        li.tbCode = this.tree.linkedObic.nameOverride || li.tbCode;
        const spos = this.tree.getAssociatedPfspos(this.compilation.type);
        const exwSorted = spos.sort((a, b) => a.doc.exwJapanDate < b.doc.exwJapanDate ? -1 : 1);
        this.obicSum = spos.length;
        this.obicNum = exwSorted.map(m => m.doc.code).indexOf(this.compilation.code) + 1;

        for (const spo of spos) {
          const doc = await this.api.loadCompilationByCode(spo.doc.code);
          if (doc.lineItems?.[0]) {
            doc.lineItems[0].partialDelivery.num = this.obicNum;
            doc.lineItems[0].partialDelivery.sum = this.obicSum;
            this.api.saveCompilation(doc);
          }
        }
        await Promise.all(exwSorted.map(async (item, idx) => {
          const doc = await this.api.loadCompilationByCode(item.doc.code);
          if (doc.lineItems?.[0]) {
            doc.lineItems[0].partialDelivery.num = idx + 1;
            doc.lineItems[0].partialDelivery.sum = this.obicSum;
            this.api.saveCompilation(doc);
          }
        }))

      }

      // if (['OC', 'PL', 'DN', 'PFSPO', 'SPO'].includes(CompilationTypeData.get(this.compilation.type).code)) {
      if (this.data.visibleMap.associatedPfspo) {
        this.loadBoxes();
      }

      // if (['OC', 'PL', 'DN'].includes(CompilationTypeData.get(this.compilation.type).code)) {
      //   await this.loadBoxes();
      // }
  
      //   if (['PFSPO', 'SPO'].includes(CompilationTypeData.get(this.compilation.type).code)) {
      //   this.getBoxBlockLines(idx, [this.compilation],[li]);
      // } else {
      //   this.getBoxBlockLines(idx, li.pfspo.flatMap(spo => spo.doc), li.pfspo.flatMap(spo => spo.docLineItem));
      // }
      // console.log('=-=-=-=-=-=-=-=->', this.boxBlockLines);

      // this.obicCodes[idx] = this.getObicCodes(li);

    })

    // this.deductibleInvoiceData.treeInvoices = [];
    // const invoices = this.tree.filterDocumentTree('IN', this.tree.findNode(this.compilation.code));
    // invoices?.forEach(async inv => {
    //   // const  = inv.lineItems.reduce((a, c: LineItemModel) => a + c.quantity * )
    //   let totalNet = inv.lineItems.reduce((a, c: LineItemModel) => {
    //     let net = c.quantity * c.piecePrice;
    //     if (c.invoicePercent > 0) net = net * c.invoicePercent / 100;
    //     // net = net + (net * c.VATPercent / 100);
    //     return a + net;
    //   }, 0);
    //   totalNet += inv.deductibleItems.reduce((a, c: DeductibleItem) => a + c.value, 0);
    //   const data = {
    //     doc: inv,
    //     payment: InvoicePaymentData.get(inv.invoicePayment)?.name || '',
    //     issueDate: (typeof inv.issueDate === 'string' ?  inv.issueDate : inv.issueDate.toISOString())?.replace(/T.*/, ''),
    //     totalNet: totalNet,
    //   }
    //   this.deductibleInvoiceData.treeInvoices.push(data);
    //   // console.log(inv);
    // })
    // console.log('invoice payment data ', this.deductibleInvoiceData);

    // console.log('change', tree);
    this.clipboardList = [];
    // this.clipboardFullList = { oc: '', dn: ''};
    this.syncClipboardList();
    // console.log('clipboardList', this.clipboardList);

    // console.log('obic codes', this.obicCodes);
  }

  deliveryValid(data: any) {
    // console.log('------------>data', data)
    const style = {
      'background-color': '#f337',
      'border': '2px solid red',
    };
    if (this.tree.linkedOC?.directDelivery == data[0].doc?.directDelivery) {
      return { 'text-align': 'center' }
    } else if (data.length && data[0].doc) {
      const shipments = data.map(m => m.doc && m.doc.directDelivery).filter(notNull => notNull);
      // console.log('------------>shipments1', shipments)
      // eslint-disable-next-line eqeqeq
      if (shipments.reduce((a, c) => a = (a != c), false)) {
        return style;
      }
    } else if (data.length && data.spo) {
      const shipments = data.map(m => m.spo && m.spo.directDelivery).filter(notNull => notNull);
      // console.log('------------>shipments2', shipments)
      // eslint-disable-next-line eqeqeq
      if (shipments.reduce((a, c) => a = (a != c), false)) {
        return style;
      }
    }
    return {
      'text-align': 'center'
    }
  }

  checkPriceFromDate(item: LineItemModel, dateType: string) {
    return (
      (
        dateType === 'dateOfDelivery' 
        && !item.dateOfDelivery
        && DocConfig.get('pricesFromDeliveryDate').docs.includes(CompilationTypeData.get(this.compilation.type).code)
      )
      || 
      ( dateType === 'dateOfDispatch'
        && !this.compilation.dateOfDispatch
        && !DocConfig.get('pricesFromDeliveryDate').docs.includes(CompilationTypeData.get(this.compilation.type).code)
      )
    )
  }

  async reloadFinishedProductPrice(el: LineItemModel, price: number = null) {
    const prices = await this.api.loadPrices(
      this.compilation.issuer,
      mongoId(this.compilation.recipient),
      mongoId(el.finishedProduct),
      DocConfig.isSalePrice(+this.compilation.type)
    );
    el.matrixPriceItem = prices;
    if (price) el.matrixPiecePrice = price;
    const idx = this.lineItems.indexOf(el);
    this.itemPrice[idx] = await this.api.loadPrice(
      this.compilation.issuer,
      mongoId(this.compilation.recipient),
      mongoId(el.finishedProduct),
      new Date(),
      this.compilation.currency,
      DocConfig.isSalePrice(+this.compilation.type)
    )
  }

  // isInvalidPrice(item: LineItemModel, idx: number, checkDate = undefined) {
  //   // console.log('isInvalidPriceDate', 
  //   //   idx, 
  //   //   this.itemPrice, 
  //   //   this.itemPrice[idx],
  //   //   new Date(this.itemPrice[idx].validTo),
  //   //   new Date(),
  //   //   new Date(this.itemPrice[idx].validTo) < new Date()
  //   // )
  //   let ret = false;
  //   // const piecePrice = item.docMetrics?.metrics.convert(+item.docMetrics.currentPriceMatrix.value, +item.docMetrics.currentPriceMatrix.type, 1);
  //   if (checkDate === false || checkDate === undefined) {
  //     // ret = item.matrixPiecePrice !== item.piecePrice || this.itemPrice[idx]?.currency !== this.compilation.currency;
  //     ret = Math.round(item.docMetrics?.metrics.matrixPiecePrice * 1000) !== Math.round(item.piecePrice * 1000)
  //       || item.docMetrics?.currentPriceMatrix?.currency !== this.compilation.currency;
  //   }
  //   if ((checkDate === true || checkDate === undefined) && !ret) {
  //     ret = (this.itemPrice[idx]?.validTo !== null) && new Date(this.itemPrice[idx]?.validTo) < new Date();
  //   }
  //   // console.log('price date invalid', item.matrixPiecePrice, item.piecePrice, item.docMetrics?.metrics.matrixPiecePrice, item.docMetrics);
  //   return ret;
  // }

  isInvalidPrice(item: LineItemModel) {
    // let ret = false;
    // if (checkDate === false || checkDate === undefined) {
    //   ret = Math.round(item.docMetrics?.metrics.matrixPiecePrice * 1000) !== Math.round(item.piecePrice * 1000)
    //     || item.docMetrics?.currentPriceMatrix?.currency !== this.compilation.currency;
    // }
    // if ((checkDate === true || checkDate === undefined) && !ret) {
    //   ret = (this.itemPrice[idx]?.validTo !== null) && new Date(this.itemPrice[idx]?.validTo) < new Date();
    // }
    // return ret;

    // check date:
    // console.log('0-0-0-0-0-0-0-0', item.docMetrics);
    if (item.docMetrics?.currentPriceMatrix && !item.docMetrics?.metrics.matrixPiecePrice) {
      // console.log('update matrix piece price called for item', item, item.docMetrics?.currentPriceMatrix);
      // item.docMetrics.updateMatrixPiecePrice?.()
      // item.docMetrics.metrics.matrixPiecePrice = item.docMetrics?.metrics.convert(
      //   +item.docMetrics.currentPriceMatrix.value, 
      //   +item.docMetrics.currentPriceMatrix.type, 
      //   1
      // );
      item.docMetrics.metrics.matrixPiecePrice = item.docMetrics?.getPiecePrice(
        +item.docMetrics.currentPriceMatrix.value, 
        +item.docMetrics.currentPriceMatrix.type,
      );
      // console.log('~~~~~~~~~~~~~~', item.docMetrics?.metrics.matrixPiecePrice)
    }
    const priceMatrix = item.docMetrics?.currentPriceMatrix;
    const matrixPiecePrice = round(item.docMetrics?.metrics.matrixPiecePrice, 3);
    const prices = item.matrixPriceItem?.price;
    // console.log('~~~~~~~~~~~~~~~~~prices', prices, item.docMetrics?.currentPriceMatrix, item.docMetrics?.metrics.matrixPiecePrice);
    const itemPiecePrice = round(item.piecePrice, 3);
    const priceDateText = item.docMetrics?.metrics.pmFromDelivery
      ? 'customer requested delivery'+ (this.checkPriceFromDate(item, 'dateOfDelivery') ? ' = today as fallback' : '')
      : item.docMetrics?.metrics.pmFromDispatch
        ? 'dispatch'+ (this.checkPriceFromDate(item, 'dateOfDispatch') ? ' = today as fallback' : '')
        : 'price';
    const matrixPriceExists = item.matrixPriceItem && item.matrixPriceItem.price.length > 0;
    const currencyMismatch = priceMatrix?.currency !== this.compilation.currency;
    const priceMismatch = matrixPiecePrice !== itemPiecePrice;

    // console.log('isInvalidPrice', matrixPiecePrice, itemPiecePrice, priceDateText, matrixPriceExists, currencyMismatch, priceMismatch, item.matrixPriceItem, item.docMetrics, item.docMetrics.calcValues.priceDate);
    const priceDate = item.docMetrics?.calcValues.priceDate && new Date(item.docMetrics?.calcValues.priceDate);
    const invalid = {} as any;
    if (!matrixPriceExists) invalid.noPMPrice = ['no PMP', 'no Price Matrix Price'];
    if (matrixPriceExists && !matrixPiecePrice) invalid.noValidPrice = [
      'no valid PMP', 
      `no valid price matrix price for ${priceDateText} date (${new DatePipe('de').transform(priceDate, 'yyyy-MM-dd')})`
    ];
    // if (!matrixPiecePrice && currencyMismatch) invalid.currencyMismatch = [`${item.docMetrics?.currentPriceMatrix?.currency} vs ${this.compilation.currency}` , 'currency mismatch'];
    if (!currencyMismatch && matrixPiecePrice && priceMismatch) invalid.priceMismatch = [
      'price mismatch', 
      `Matrix price (${matrixPiecePrice}) <> Item price (${itemPiecePrice}) for ${priceDateText} date (${new DatePipe('de').transform(priceDate, 'yyyy-MM-dd')})`
    ];
    // if (!item.docMetrics.calcValues.priceDate) invalid.noPriceDate = ['no price date', `invalid date for ${priceDateText} date`];
    if (this.checkPriceFromDate(item, 'dateOfDelivery')) {
      // return { length: 1, invalidPriceDate: ['no ETA date', `no customer requested delivery date set`] };
      invalid.invalidPriceDate = ['no price date', `no customer requested delivery date set`];
    } else if (this.checkPriceFromDate(item, 'dateOfDispatch')) {
      // return { length: 1, invalidPriceDate: ['no ETA date', `no dispatch date set`] };
      invalid.invalidPriceDate = ['no price date', `no dispatch date set`];
    } 

    if (priceMatrix?.validTo && (priceDate > new Date(priceMatrix.validTo))) {
      invalid.invalidPriceDate = ['price date out of bounds', `Price date: ${new DatePipe('de').transform(priceDate, 'yyyy-MM-dd')} > valid to date: ${new DatePipe('de').transform(priceMatrix.validTo, 'yyyy-MM-dd')}`];
    }
    return  { length: Object.keys(invalid)?.length, ...invalid };
    

  }

  checkInvalidPrices(li: LineItemModel, idx: number/*, forced = true*/) {
    /*if (li.docMetrics && (!this.invalidPriceItems[idx] || forced)) {*/
      this.invalidPriceItems[idx] = this.isInvalidPrice(li);
    /*}*/
    return true;
  }

  // isUnitMismatch(item: LineItemModel, idx: number) {
  //   // let ret = (item.matrixPriceItem && item.matrixPriceItem.price[0].type !== this.itemPrice[idx].type);
  //   let ret = +item.docMetrics?.calcValues?.priceUnit !== +this.itemPrice[idx]?.type;
  //   // console.log('price unit mismatch', ret, +item.docMetrics?.calcValues?.priceUnit, +this.itemPrice[idx]?.type, item.docMetrics?.calcValues);
  //   return ret;
  // }

  async reloadFinishedProducts() {
    const newLis = [];
    for (const el of this.lineItems) {
      const fp = this.data.finishedProducts.find(f => mongoId(f) === mongoId(el.finishedProduct));
      el.finishedProduct = fp;
      await this.reloadFinishedProductPrice(el);
      const dm = new DocMetrics(this.api, this.compilation, el, this.roundPipe, this.data, false);
      await dm.init();
      const price = dm.calcValues.price;
      const priceUnit = dm.calcValues.priceUnit
      el.matrixPiecePrice =  price && +priceUnit > 1 ? dm.metrics.convert(+price, 1, +priceUnit) : +price;
      el.docMetrics = {
        metrics: dm.metrics,
        calcValues: dm.calcValues,
        currentPriceMatrix: dm.currentPriceMatrix,
        isEnergy: dm.isEnergy,
        getPiecePrice: dm.getPiecePrice.bind(dm),
      }
      for (let i = 0; i < el.matrixPriceItem?.price.length; i++) {
        el.matrixPriceItem.price[i] = Object.assign(
          { piecePrice: dm.metrics.convert(+el.matrixPriceItem.price[i].value, 1, +el.matrixPriceItem.price[i].type) }, 
          el.matrixPriceItem.price[i]
        );
      }
      newLis.push(el);
    };
    // console.log('new lis', newLis, newLis.map(m => m.pfspo));

    let hasBeenOverwritten = false;
    for (let i = 0; i < newLis.length; i++) {
      if (!this.lineItems[i] || mongoId(newLis[i].finishedProduct) !== mongoId(this.lineItems[i].finishedProduct)) hasBeenOverwritten = true;
    }

    if (!hasBeenOverwritten) {
      if (this.optional) {
        this.compilation.optionalLineItems = this.lineItems = newLis;
      } else {
        this.compilation.lineItems = this.lineItems = newLis;
      }
    }
    // console.log('===> line items init', this.compilation.lineItems.length, this.lineItems.length);
    // console.trace()

  }

  async onProductSelected(idx, item, openLineItemMetrics = true) {
    console.log('onProductSelected create new', idx, item, openLineItemMetrics);
    await this.reloadFinishedProducts();
    const finishedProduct = item._id ? item : this.data.finishedProducts.find(f => mongoId(f) === mongoId(item)); // await this.api.loadFinishedProductById(item.id);
    //const baseProduct = this.data.baseProducts.find(f)
    if (idx < 0) {
      const li = new LineItemModel();
      li.pfspo = [];
      idx = 0; this.lineItems.unshift(li);
    }
    // TODO: why copy?
    const li = Object.assign({ matrixPiecePrice: 0, matrixPriceItem: null }, this.lineItems[idx])
    li.finishedProduct = finishedProduct; // item.id;
    // TODO: use calcName
    li.productName = finishedProduct.calcCode + '; ' + finishedProduct.calcName;
    li.hsCode = finishedProduct.hs;
    const externalName = finishedProduct.externalName;
    const externalCode = finishedProduct.externalCode;
    li.attributeRemark = externalName || undefined;
    li.attributeCode = externalCode || undefined;
    li.publicRemark = finishedProduct.publicRemark;
    // li.countryOfOrigin = finishedProduct.product?.countryOfOrigin || finishedProduct.countryOfOrigin || undefined;
    console.log('onProductSelected', finishedProduct.product?.countryOfOrigin, finishedProduct.countryOfOrigin, finishedProduct);
    this.lineItems[idx] = li;
    this.recalc();

    if (openLineItemMetrics) await this.openLineItemMetrics(li);
    if (['FCOR', 'OR'].includes(CompilationTypeData.get(this.compilation.type).code)) {
      this.dialogService.open(CommonDialogComponent, {
        context: {
          dialogType: NrkDialogType.dateSelection,
          header: 'Select date of delivery',
          message: li.productName
        },
      }).onClose.subscribe(async x => {
        if (x && x.response && x.response.date) {
          li.dateOfDelivery = x.response.date;
        }
        console.log('onProductSelected', idx, item);
      })
    }
    console.log('onProductSelected', idx, item, openLineItemMetrics, finishedProduct);

  }

  async onProductsSelected(data: { fp: FinishedProductModel[], rows: any[] }) {
    console.log('onProductsSelected', data);
    this.generatingFinishedProducts = true;
    for (const fp of data.fp) {
      this.onNewLineItem();
      await this.onProductSelected(this.lineItems.length-1, fp, false);
      const fpRow = data.rows && data.rows.find(f => f.finishedProductId === fp._id);
      const lineItem = this.lineItems[this.lineItems.length - 1];
      if (fpRow) {
        lineItem.displayUnitQuantity = +fpRow['c-quantity'] || 0;
        lineItem.displayUnit = +fpRow['c-type'] || 1;
        lineItem.displayUnitPrice = +fpRow['c-value'] || 0;
        const net = lineItem.displayUnitQuantity * lineItem.displayUnitPrice;
        const dm = new DocMetrics(this.api, this.compilation,this.lineItems[this.lineItems.length-1], this.roundPipe, this.data);
        lineItem.quantity = dm.metrics.convert(lineItem.displayUnitQuantity, lineItem.displayUnit, 1);
        lineItem.piecePrice = net / lineItem.quantity;
        this.recalc();
      }
    }
    this.generatingFinishedProducts = false;
  }

  getType(type: string) {
    return CompilationTypeData.get(type).id;
  }

  isPartialPayment() {
    return +this.compilation.invoicePayment === 1 || +this.compilation.invoicePayment === 2 // down payment || partial payment
  }

  isDiscount() {
    return !this.isPartialPayment()
      && (this.lineItems || []).find(li => li.discount > 0);
  }

  showRoundedPrice(item: LineItemModel, rounded = true) {
    
    if (!item.calculatedPiecePrice) { // legacy
      item.calculatedPiecePrice = item.piecePrice;
    }

    if (rounded) {
      item.piecePrice = +this.roundPipe.transform(item.calculatedPiecePrice, 3);
    } else {
      item.piecePrice = item.calculatedPiecePrice;
    }
    this.recalc();
  }

  // TODO: update calls in html
  recalc() {
    this.deductibleItems && this.deductibleItems.forEach(d => d.value = +d.value);
    this.deductibleTotal = this.deductibleItems &&
                         this.deductibleItems.reduce((sum, item) => sum + (1 * item.value), 0);
    // this.ppInvoicesTotal = this.compilation.paymentPlan?.items?.reduce((a, c) => a + (c.invoices?.reduce((ia, ic) => ia + (ic.net || 0), 0 )), 0);
    this.ppInvoicesTotal = 0;
    this.compilation.paymentPlan?.items?.forEach(item => {
      item?.invoices?.forEach(inv => {
        this.ppInvoicesTotal += (inv.net || 0)
      })
    });
    // this.ppInvoicesTotal = this.compilation.paymentPlanInvoicesTotal;

    if (this.isDiscount()) {
      this.lineItems.forEach(li => li.discount = li.discount ? li.discount : 0);
    }

    this.vatItems = [];
    if (this.lineItems) {
      this.lineItems.forEach((li, idx) => {

        this.obicCodes[idx] = this.getObicCodes(li);
        
        // fix quantity rounding issue (10 decimals)
        li.quantity = Number(li.quantity?.toFixed(10))
         
        if ((li.displayUnitPrice === 0 && li.piecePrice === undefined) || (li.displayUnitPrice === 0 && li.piecePrice === undefined)) {
          li.displayUnitPrice = li.piecePrice = li.metricsPrice = li.matrixPiecePrice = 0;
        }
        const vat = +li.VATPercent;
        if (vat >= 0) {
          if (!this.vatItems.find(s => s.vat === vat)) {
            this.vatItems.push({ vat: vat, sum: 0, partialVat: 0, discountedVat: 0});
          }
          this.vatItems.find(s => s.vat === vat).sum += li.quantity * li.piecePrice;
          this.vatItems.find(s => s.vat === vat).partialVat += li.quantity * li.piecePrice * li.invoicePercent / 100;
          this.vatItems.find(s => s.vat === vat).discountedVat
            += li.quantity * li.piecePrice * (100-li.discount) / 100;
        }

        // auto calculate pallet quantity
        const fpds = li.finishedProduct?.packingSpec?.map(m => this.data.getPackingConfig(m));
        const boxTypes = li.boxDetails?.[0]?.boxType; // li.pfspo.map(m => m.docLineItem.boxDetails?.[0]?.boxType);
        const fpd = fpds?.find(f => boxTypes?.includes(f.cartonBox));
        if (fpd) {
          const boxCount = Array.from(new Set(li.boxDetails?.map(m => m.boxId)))?.length;
          // console.log('packing Def', boxCount, fpds, fpd, boxTypes, li.pfspo, li.finishedProduct);
          this.calcPalletQty[idx] = Math.ceil(Math.ceil(boxCount / fpd.boxesPerLayer) / fpd.layersPerPallet);
        }
      })
    }
    if (this.vatItems.length > 0) {
      this.vatItems[0].sum += this.deductibleTotal + this.ppInvoicesTotal;
      this.vatItems[0].partialVat += this.deductibleTotal + this.ppInvoicesTotal;
      this.vatItems[0].discountedVat += this.deductibleTotal + this.ppInvoicesTotal;
    }

    this.subTotal = this.lineItems && this.lineItems
      .reduce((sum, item) => sum + (item.quantity * item.piecePrice), 0)
    this.partialSubTotal = this.lineItems && this.lineItems
      .reduce((sum, item) => sum + (item.quantity * item.piecePrice * (item.invoicePercent/100)), 0)
    this.discountedSubTotal = this.lineItems && this.lineItems
      .reduce((sum, item) => sum + (item.quantity * item.piecePrice * ((100-item.discount)/100)), 0)
    this.netTotal = this.subTotal +  this.deductibleTotal;
    this.partialNetTotal = this.partialSubTotal + this.deductibleTotal;
    this.discountedNetTotal = this.discountedSubTotal + this.deductibleTotal;
    this.ppNetTotal = this.netTotal + this.ppInvoicesTotal;
    this.ppPartialNetTotal = this.partialNetTotal + this.ppInvoicesTotal;
    this.ppDiscountedNetTotal = this.discountedNetTotal + this.ppInvoicesTotal;
    this.vatTotal = this.vatItems && this.vatItems.reduce((sum, item) => sum + (item.sum * item.vat / 100), 0);
    this.partialVatTotal = this.vatItems && this.vatItems
      .reduce((sum, item) => sum + (item.partialVat * (item.vat / 100)), 0);
    this.discountedVatTotal = this.vatItems && this.vatItems
      .reduce((sum, item) => sum + (item.discountedVat * (item.vat / 100)), 0);
    this.sumTotal = this.ppNetTotal + this.vatTotal;
    this.partialSumTotal = this.ppPartialNetTotal + this.partialVatTotal;
    this.discountedSumTotal = this.ppDiscountedNetTotal + this.discountedVatTotal;
    this.lineItemsChanged.emit(this.compilation);

   if (this.lineItems.find(f => f.calculatedPiecePrice)) {
      this.calculatedSubTotal = this.lineItems?.reduce((sum , item) => 
        sum + (item.quantity * (+this.roundPipe.transform(item.calculatedPiecePrice ? item.calculatedPiecePrice : item.piecePrice, 9))), 0 // TODO: legacy
      );
    } else {
      this.calculatedSubTotal = this.lineItems?.reduce((sum , item) => 
        sum + (item.quantity * (+this.roundPipe.transform(item.calculatedPiecePrice ? item.calculatedPiecePrice : item.piecePrice, 3))), 0 // TODO: legacy
      );
    }
    this.calculatedTotal = this.calculatedSubTotal ? this.calculatedSubTotal + this.vatTotal : 0;

    setTimeout(() => { // run outside change detection
      if (this.isPartialPayment()) {
        this.data.totalNet = new RoundPipe().transform(this.partialSumTotal, 2);
      } else if (this.isDiscount()) {
        this.data.totalNet = new RoundPipe().transform(this.discountedSumTotal, 2);
      } else {
        this.data.totalNet = new RoundPipe().transform(this.sumTotal, 2);
      }
    });

    // console.log(`== calculated sums ==
    // this.subTotal: ${this.subTotal}
    // this.partialSubTotal: ${this.partialSubTotal}
    // this.discountedSubTotal: ${this.discountedSubTotal}
    // this.discountedSumTotal: ${this.discountedSumTotal}
    // this.discountedNetTotal: ${this.discountedNetTotal}
    // this.vatTotal: ${this.vatTotal}
    // this.partialVatTotal: ${this.partialVatTotal}
    // this.discountedVatTotal: ${this.discountedVatTotal}
    // this.partialSumTotal: ${this.partialSumTotal}
    // this.partialNetTotal: ${this.partialNetTotal}
    // this.calculatedSubTotal: ${this.calculatedSubTotal}
    // this.calculatedTotal: ${this.calculatedTotal}
    // this.sumTotal: ${this.sumTotal}
    // this.netTotal: ${this.netTotal}
    // this.data.totalNet: ${this.data.totalNet}`);

    // console.log('recalced...', this.data.totalNet);

    // console.log('obic codes', this.obicCodes);
  }

  recalcQuantities() {
    this.totalQuantity = { pc: 0, m: 0, m2: 0, kg: 0 };
    this.lineItems.forEach(async li => {
      const metrics = new DocMetrics(this.api, this.compilation, li, this.roundPipe, this.data, false);
      await metrics.init();
      metrics.calc();
      console.log('metrics', metrics);
      this.totalQuantity.pc += li.quantity;
      this.totalQuantity.m += metrics.metrics.m;
      this.totalQuantity.m2 += metrics.metrics.m2;
      this.totalQuantity.kg += metrics.metrics.kg;
    })
  }

  getTotalNet(all = true) {
    if (this.isPartialPayment()) {
      return new RoundPipe().transform(all ? this.partialSumTotal : this.partialNetTotal, 2);
    } else if (this.isDiscount()) {
      return new RoundPipe().transform(all ? this.discountedSumTotal : this.discountedNetTotal, 2);
    } else {
      this.data.totalNet = new RoundPipe().transform(this.sumTotal, 2);
      return all ? this.data.totalNet : new RoundPipe().transform(this.netTotal, 2);
    }
  }

  async updateAllPrices() {
    if (this.lineItems) {
      this.lineItems.forEach(async item => {
        const metrics = new DocMetrics(this.api, this.compilation, item, this.roundPipe, this.data);
        // console.log('update all prices', item, metrics)
        await metrics.setPrice(true);
        metrics.calc();
        metrics.save();
        // console.log('update all prices2', item, metrics)
      });
    }
    await this.reloadFinishedProducts();
    this.recalc();
  }

  async checkPrices() {
  }

  transferAllPrices() {
    if (this.lineItems) {
      this.lineItems.forEach(async item => {
        this.transferPrice(item);
      });
    }
  }

  async transferPrice(lineItem: LineItemModel) {
    const doctype = CompilationTypeData.get(this.compilation.type);
    const pricetype = DocConfig.get('prices').docs.indexOf(doctype.code);
    let unit = lineItem.displayUnit;
    let price = lineItem.discount > 0 ? lineItem.displayUnitPrice*(1-lineItem.discount/100) : lineItem.displayUnitPrice;

    // const pm = await this.api.loadPrice(
    //   this.compilation.issuer,
    //   mongoId(this.compilation.recipient),
    //   mongoId(lineItem.finishedProduct),
    //   new Date('2500-12-12'),
    //   this.compilation.currency,
    //   DocConfig.get('prices').price[pricetype] !== 'PP',
    // )
    // if (pm) {
    //   const dm = new DocMetrics(this.api, this.compilation, lineItem, this.decimalPipe, false);
    //   await dm.init();
    //   price = dm.metrics.convert(price, +pm.type, +unit);
    //   unit = pm.type;
    //   console.log('dm', dm, price, unit);
    // }

    await this.api.savePrice(
      this.compilation.issuer,
      mongoId(this.compilation.recipient),
      mongoId(lineItem.finishedProduct),
      new Date(),
      new Date(this.compilation.etaCustomerDate),
      this.compilation.currency,
      DocConfig.get('prices').price[pricetype] === 'PP' ? EAccountingType.Purchase : EAccountingType.Sale,
      +unit,
      +price.toFixed(6),
    );
    // this.reloadFinishedProductPrice(lineItem, price);
    this.reloadFinishedProducts();
    this.toastrService.success(
      `price ${+price.toFixed(6)} ${this.compilation.currency} per ${UnitData.get(+unit).short} transferred`,
      'price matrix'
    );
  }

  assignPFSPO(item: LineItemModel, idx: number) {
    // console.log('--->assign', this.compilation);
    this.dialogService.open(CommonDialogComponent, {
      context: {
        dialogType: NrkDialogType.pfspoSelector,
        compilation: this.compilation,
        lineItem: item,
        disabled: this.disabled,
        recalc: this.recalc, // pass recalc() function
      },
    }).onClose.subscribe(async x => {

      if (x && x.response && x.response.code) {

        if (item.pfspo?.map(m => m.code)?.includes(x.response.code)) {
          this.toastrService.danger(`${x.response.code} is already assigned`, 'Assign Error');
          return null;
        }

        const el = new AssociatedPfspo()
        el.code = x.response.code;
        el.version = x.response.version;
        el.lineItem = x.response.lineItem;
        el.internalPos = x.response.internalPos;
        el.pos = x.response.pos;
        el.parentPos = idx;


        const doc = this.compilation._id ? await this.api.loadCompilationByCode(this.compilation.code) : this.compilation;
        // console.log('assignPFSPO',idx, doc?.lineItems, doc?.lineItems[idx]);
        // doc.lineItems[idx].pfspo.push(el);
        // this.api.saveCompilation(doc);
        if (this.compilation._id) await this.tree.synchronizeSharedFields(doc);

        el.doc = await this.api.loadCompilationByCode(el.code);
        if (el.internalPos !== undefined) {
          el.docLineItem = el.doc.lineItems.find(f => f.position.internalPos === el.internalPos);
        } else {
          // legacy
          el.docLineItem = el.doc.lineItems[el.pos-1];
        }

        this.dialogService.open(CommonDialogComponent, {
          context: {
            dialogType: NrkDialogType.pfspoAvailability,
            compilation: this.compilation,
            lineItem: item,
            position: idx, // line item index
            pfspo: el,
            disabled: this.disabled,
            recalc: this.recalc,
          },
        }).onClose.subscribe(async x => {
          // console.log('pfspoAvailability', x);
          if (x?.button === NrkDialogButton.save) {
            // if (el.doc.testCertificates?.length) {
            //   this.compilation.testCertificates.push(...el.doc.testCertificates);
            // }
            item.pfspo.push(el);
            if (this.compilation._id) {
              const doc = await this.api.loadCompilation(mongoId(this.compilation));
              doc.lineItems[idx].pfspo = item.pfspo;
              this.api.saveCompilation(doc);
            } else {
              this.documentComponent.saveItem(this.compilation, true, true); // probably not needed
            }
            this.loadBoxes();
            
          }
        })

      }
    })
  }


  // boxBlockLines = [];
  // setBoxBlockLines(bbl: any) {
  //   this.boxBlockLines = bbl;
  // }

  // getBoxBlockValues(field: string, lineItemIdx: number) {
  //   console.log('----------->tbcode', this.compilation.lineItems[lineItemIdx].tbCode);
  //   return this.boxBlockLines[lineItemIdx]?.map(m => m[field]).join('\n') || 'N/A';
  //   // return this.lineItems[lineItemIdx].pfspo?.map(m => m.docLineItem && m.docLineItem[field]?.replace(/T\d\d\:\d\d\:\d\d.*/,''))?.filter(notNull => notNull).join('\n') || 'n/a';
  // }

  async removePFSPO(item: LineItemModel, el: AssociatedPfspo, idx) {
    // const boxes = this.spoBoxes[idx][el.code]?.filter(box => box.status > EBoxStatus.assignedSpo && box.docRef === this.compilation.code);
    // const pallets = Array.from(new Set(boxes.map(m => m.palletRef)))?.sort((a, b) => a > b ? 1 : -1);
    // // const pallets = this.compilation.packingConditions.filter(f => f.lineItemIdx === idx && )
    // console.log('remove pfspo.....', item, el, idx, boxes, pallets, pallets.length);
    // if (pallets?.length) {
    //   if (!this.compilation.packingConditions?.filter(f => f.lineItemIdx === idx)?.length) {
    //     for (const box of boxes) {
    //       console.log('pal', box.docRef);
    //       box.docRef = null;
    //       box.dispatchDate = null;
    //       box.docRefPos = -1;
    //       box.docRefProduct = null;
    //       box.palletRef = null;
    //     }
    //     this.api.saveSpoBoxes(boxes);
    //   } else {
    //     this.toastrService.danger(`${pallets.length > 1 ? 'Pallets '+pallets.join(',')+' are' : 'Pallet '+pallets[0]+' is'} assigned in Packing Details`, 'can\'t remove (PF)SPO');
    //     return;
    //   }
    // }
    // item.pfspo = item.pfspo.filter(f => f.code !== el.code);
    // this.spoBoxes[idx][el.code].forEach(((el: SpoBoxModel) => {
    //   el.docRef = null;
    //   el.docRefPos = null;
    //   el.docRefProduct = null;
    //   el.status = EBoxStatus.free;
    //   el.dispatchDate = null;
    //   el.palletRef =null;
    // }));
    // this.api.saveSpoBoxes(this.spoBoxes[idx][el.code]);
    this.spoBoxes[idx][el.code] = await this.api.loadSpoBoxes({spo: el.code});
    const boxes = this.spoBoxes[idx][el.code]?.filter(box => box.docRef === this.compilation.code);
    const pallets = Array.from(new Set(boxes.map(m => m.palletRef)))?.sort((a, b) => a > b ? 1 : -1);
    if (pallets?.filter(notNull => notNull)?.length) {
      this.toastrService.danger(`${pallets.length > 1 ? 'Pallets '+pallets.join(',')+' are' : 'Pallet '+pallets[0]+' is'} assigned in Packing Details`, 'can\'t remove (PF)SPO');
      return;
    }

    item.pfspo = item.pfspo.filter(f => f.code !== el.code);
    boxes.forEach(((el: SpoBoxModel) => {
      el.docRef = null;
      el.docRefPos = null;
      el.docRefProduct = null;
      el.status = EBoxStatus.free;
      el.dispatchDate = null;
      el.palletRef =null;
    }));

    this.api.saveSpoBoxes(boxes);

    const doc = await this.api.loadCompilationByCode(this.compilation.code);
    doc.lineItems[idx].pfspo = doc.lineItems[idx].pfspo.filter(f => f.code !== el.code);
    // this.api.saveSpoBoxes(this.spoBoxes[idx][el.code]);
    this.api.saveCompilation(doc);
  }

  getExpiryData(item: LineItemModel, spoCode: string, idx: number) {

    if (!this.spoBoxes || !this.spoBoxes[idx] || !this.spoBoxes[idx][spoCode]) return;

    const oldestProductionDate = Math.min(...this.spoBoxes[idx][spoCode]?.flatMap(m => m.prodDate?.map(pd => new Date(pd)?.getTime())));
    const newestProductionDate = Math.max(...this.spoBoxes[idx][spoCode]?.flatMap(m => m.prodDate?.map(pd => new Date(pd)?.getTime())));
    let expiryMonthsAtLowestTemp = item.finishedProduct?.product?.shelfLife5Deg;
    if (!expiryMonthsAtLowestTemp) expiryMonthsAtLowestTemp = item.finishedProduct?.product?.shelfLife10Deg;
    if (!expiryMonthsAtLowestTemp) expiryMonthsAtLowestTemp = item.finishedProduct?.product?.shelfLife20Deg;
    let minRemainingShelfLifeAtDispatch = moment(oldestProductionDate).add(expiryMonthsAtLowestTemp, 'months')?.diff(this.compilation.vieDispatchDate, 'days');
    let minRemainingShelfLifeAtDispatchMonths = moment.duration(minRemainingShelfLifeAtDispatch, 'days')?.asMonths();

    if (item.finishedProduct?.boxLabelPriority >= 9 && item.finishedProduct?.boxLabelPriority <= 11) {
      expiryMonthsAtLowestTemp = item.finishedProduct?.product?.shelfLifeFromDispatch5Deg;
      // console.log('expiryMonthsAtLowestTemp', expiryMonthsAtLowestTemp, item.finishedProduct?.product?.shelfLifeFromDispatch5Deg, item.finishedProduct?.product?.shelfLifeFromDispatch10Deg, item.finishedProduct?.product?.shelfLifeFromDispatch20Deg);
      if (!expiryMonthsAtLowestTemp) expiryMonthsAtLowestTemp = item.finishedProduct?.product?.shelfLifeFromDispatch10Deg;
      if (!expiryMonthsAtLowestTemp) expiryMonthsAtLowestTemp = item.finishedProduct?.product?.shelfLifeFromDispatch20Deg;
      minRemainingShelfLifeAtDispatch = moment(this.compilation.vieDispatchDate).add(expiryMonthsAtLowestTemp, 'months')?.diff(this.compilation.vieDispatchDate, 'days');
      minRemainingShelfLifeAtDispatchMonths = moment.duration(minRemainingShelfLifeAtDispatch, 'days')?.asMonths();
    }

    let warningText = null;
    if (minRemainingShelfLifeAtDispatch < 0) {
      warningText = 'Product expired at time of dispatch';
    }
    if (minRemainingShelfLifeAtDispatch < 180) {
      warningText = `Remaining shelf life at dispatch date < ${minRemainingShelfLifeAtDispatchMonths} months`;
    }
    if (!expiryMonthsAtLowestTemp) {
      warningText = `No shelf life temperature and months set in base product ${item.finishedProduct?.product?.name}`;
    }

    // console.log('expiryData', item, spo, idx, this.spoBoxes[idx][spoCode],
    //   { oldestProductionDate, newestProductionDate, expiryMonthsAtLowestTemp, minRemainingShelfLifeAtDispatch, minRemainingShelfLifeAtDispatchMonths, warningText }
    // )

    return ({ oldestProductionDate, newestProductionDate, expiryMonthsAtLowestTemp, minRemainingShelfLifeAtDispatch, minRemainingShelfLifeAtDispatchMonths, warningText })
  }

  openPfspoAvailability(item: LineItemModel, idx) {
    // this.dialogService.open(CommonDialogComponent, {
    //   context: {
    //     dialogType: NrkDialogType.pfspoAvailability,
    //     compilation: this.compilation,
    //     lineItem: item,
    //     position: idx, // line item index
    //     disabled: true,
    //     recalc: this.recalc,
    //     pfspo: null,
    //   },
    // })
    this.dialogService.open(CommonDialogComponent, {
      context: {
        dialogType: NrkDialogType.pfspoSelector,
        compilation: this.compilation,
        lineItem: item,
        disabled: true,
      }
    })
  }

  getSumAssignedQ(item: LineItemModel) {
    return item.pfspo.reduce((a, c) => a + (+c.quantity), 0);
  }

  getSumAssignedBoxes(idx: number) {

    // return this.lineItems[idx]?.pfspo?.reduce((a, spo) => {
    //   if (!this.spoBoxes[idx]) return a;
    //   const spoQuantity = this.spoBoxes[idx][spo.code]
    //     ?.filter(f => f.docRefPos === this.lineItems[idx].position?.internalPos)
    //     ?.reduce((qa, qbox: SpoBoxModel) => 
    //       qa + ((qbox.selected || qbox.status === EBoxStatus.assignedSpo) && qbox.quantity || 0)
    //     , 0);
    //   return a + spoQuantity;
    // }, 0);

    // console.log('==========================================================\ngetSumAssignedBoxes')

    return this.lineItems[idx].pfspo?.reduce((spoa, spo) => {
      // console.log('getSumAssignedBoxes', this.lineItems[idx], spoa, spo);
      if (!this.spoBoxes[idx] || !this.spoBoxes[idx][spo.code]) return 0
      return spoa + this.spoBoxes[idx][spo.code]
        ?.filter((box: SpoBoxModel) => {
          // console.log('box', box.boxId, box.docRef, this.tree.linkedOC.code, box.docRefPos, this.lineItems[idx].position?.internalPos, box.status);
          // console.log('->box', box.docRef === this.compilation.code && box.docRefPos === this.lineItems[idx].position?.internalPos && box.status > EBoxStatus.free);
          return box.docRef === this.tree.linkedOC.code && box.docRefPos === this.lineItems[idx].position?.internalPos && box.status > EBoxStatus.free
        })
        ?.reduce((a: number, c: SpoBoxModel) => a + c.quantity, 0)
    }, 0)
  }

  // async getBoxes(spo: AssociatedPfspo): SpoBoxModel[] {

  //   // const lineItem = this.tree.linkedPfspos?.find(f => f.code === spo.code)?.lineItems[0];
  //   // if (!lineItem?.boxDetails?.length) return;

  //   // const grp = {};
  //   // lineItem.boxDetails?.forEach(el => {
  //   //     if (!grp[el.case]) grp[el.case] = { status: EBoxStatus.free, case: el.case, quantity: 0 }
  //   //     grp[el.case].quantity += (+el.quantity);
  //   // })
  //   // spo.boxes?.forEach(el => {
  //   //   grp[el.case] = el
  //   //   const fp = this.data.finishedProducts?.find(f => mongoId(f) === mongoId(lineItem.finishedProduct));
  //   //   grp[el.case].weight = fp?.product.weight * fp?.content.energy.rollLength * fp?.content.energy.width * grp[el.case].quantity;
  //   // });
  //   return new Promise(res => {
  //     res(this.data.spoBoxes.filter(f => f.spo === spo.code))
  //   })
  //   // return Object.values(grp);
  // }

  getDates(dates: Date[]) {
    return dates.map(d => d.toISOString()?.replace(/T.*/, ''));
  }


  getOCItem(item: LineItemModel) {
    // console.log(item.pfspo?.map(m => m.code))
    return this.tree.linkedOC?.lineItems.find(f => f.position?.internalPos === item.position?.internalPos);
  }

  // onOcSelected(item: LineItemModel, idx: number, oc: any) {
  //   this.addOC(item, idx, oc);
  // }

  // getDeliveredQ(item: LineItemModel) {
  //   return item.relatedOCs.reduce((a, c) => a + (c.doc.completelyInvoiced ? +c.quantity : 0), 0);
  // }

  // getAssignedQ(item: LineItemModel) {
  //   return item.relatedOCs.reduce((a, c) => a + (!c.doc.completelyInvoiced ? +c.quantity : 0), 0);
  // }

  // getAvailableQ(item: LineItemModel) {
  //   return item.quantity - item.relatedOCs.reduce((a, c) => a + (c.doc.completelyInvoiced ? +c.quantity : 0), 0);
  // }

  // getFreeQ(item: LineItemModel) {
  //   return item.quantity - item.relatedOCs.reduce((a, c) => a + (+c.quantity), 0);
  // }

  // async toggleCompletelyInvoiced(oc: CompilationModel, state: boolean) {
  //   const doc = await this.api.loadCompilationByCode(oc.code)
  //   doc.completelyInvoiced = oc.completelyInvoiced = state;
  //   console.log('toggle completely invoiced', doc.completelyInvoiced);
  //   this.api.saveCompilation(doc);
  // }

  openLineItemMetrics(item: LineItemModel): Promise<boolean> {
    return new Promise<boolean>(async resolve => {
      // // TODO: where is this overwritten?
      // if (!item.finishedProduct?.code) {
      //   item.finishedProduct = this.data.finishedProducts.find(f => mongoId(f) === mongoId(item.finishedProduct));
      // }

      // reload finished product
      item.finishedProduct = await this.api.loadFinishedProductById(mongoId(item.finishedProduct));
      
      this.dialogService.open(CommonDialogComponent, {
        context: {
          dialogType: NrkDialogType.metrics,
          compilation: this.compilation,
          lineItem: item,
          disabled: this.disabled,
          recalc: this.recalc, // pass recalc() function
        },
      }).onClose.subscribe(async () => {
        this.lineItemsChanged.emit(this.compilation);
        await this.reloadFinishedProducts();
        this.recalc();
        this.recalcQuantities();
        // this.checkInvalidPrices(item, this.lineItems.indexOf(item), true);
        resolve(true);
      });
    });
  }

  getProductCode(lineItem: LineItemModel) {
    const item = lineItem.finishedProduct;
    const code = item.code ? item.code + '; ' : '';
    const name = item.product && item.product.name ? item.product.name + '; ' : '';
    const dim = item.content && item.content.energy.core ?
      item.content.energy.width + '/'
                + item.content.energy.rollLength + '/'
                + item.content.energy.core.name
      : '';
    return code + name + dim;
  }

  onNewLineItem() {
    if ((
        this.compilation.type === CompilationTypeData.get('OBIC').id 
        || (['PFSPO', 'SPO'].includes(CompilationTypeData.get(this.compilation.type).code) && this.tree.linkedObic)
      ) && this.lineItems.length >= 1) {
      this.toastrService.danger('OBIC documents can only have one line item', 'One line item only');
      return;
    } 
    if (!this.lineItems) this.lineItems = [];
    const lineItem = new LineItemModel();
    lineItem.VATPercent = this.compilation.vatGlobal;
    if (this.compilation.invoicePercent) lineItem.invoicePercent = this.compilation.invoicePercent;
    if (this.compilation.discount) lineItem.discount = this.compilation.discount;
    lineItem.pfspo = [];
    lineItem.position = new LineItemPosition();
    lineItem.position.id = uniqid.time();
    lineItem.position.internalPos = this.lineItems.reduce((a, c) => Math.max(a, c.position.internalPos), 0) + 1 || 0;
    lineItem.position.orderPos = -1;
    for (const itemline of BarcodesComponent.sConfig.item) {
      if (!['lpn', 'lar'].includes(itemline.code)) this.compilation.barcodes.push(itemline.code + '-' + this.lineItems.length);
    }
    this.lineItems.push(lineItem);
    this.recalc();
    this.recalcQuantities();
    this.lineItemsChanged.emit(this.compilation);
    return lineItem;
  }

  onRemoveLineItem(idx: number) {
    this.lineItems.splice(idx, 1);
    this.recalc();
    this.recalcQuantities();
    this.lineItemsChanged.emit(this.compilation);
  }

  onMoveLineItem(idx: number, up: boolean) {
    const cut = this.lineItems.splice(idx, 1);
    this.lineItems.splice(idx + (up ? -1 : 1), 0, cut[0]);
  }

  cloneLineItem(item: LineItemModel, idx: number) {
    const clonedItem = JSON.parse(JSON.stringify(item)) as LineItemModel;
    clonedItem.dateOfDelivery = undefined;
    clonedItem.position.internalPos = this.lineItems.reduce((a, c) => Math.max(a, c.position.internalPos), 0) + 1;
    this.lineItems.splice(idx+1, 0, clonedItem);
  }

  onOptionalToLineItem(idx: number, direction: boolean) {
    if (direction) { // optional to line item
      const cut = this.lineItems.splice(idx, 1);
      this.compilation.lineItems.push(cut[0]);
    } else { // line item to optional
      const cut = this.lineItems.splice(idx, 1);
      this.compilation.optionalLineItems.push(cut[0]);
    }
    this.recalc();
  }

  onNewDeductibleItem(/* event */) {
    const di = new DeductibleItem();
    this.deductibleItems.push(di);
    this.lineItemsChanged.emit(this.compilation);
  }

  onRemoveDeductibleItem(idx: number) {
    this.deductibleItems.splice(idx, 1);
    this.recalc();
    this.lineItemsChanged.emit(this.compilation);
  }

  onMoveDeductibleItem(idx: number, up: boolean) {
    const cut = this.deductibleItems.splice(idx, 1);
    this.deductibleItems.splice(idx + (up ? -1 : 1), 0, cut[0]);
  }

  setDeductibleText(item, inv) {
    // console.log('set deductible text', item, inv)
    item.description = `${inv.doc.code}${inv.payment ? ', '+inv.payment : ''}, ${inv.issueDate}`;
    item.value = -inv.totalNet;
    this.hidePopovers();
  }

  onVatGlobalChanged(vat: number) {
    this.lineItems.forEach(item => item.VATPercent = vat);

    console.log('compilation', this.compilation, this.compilation.lineItems, this.lineItems);
    this.recalc();
  }

  onInvoicePercentChanged(perc: number) {
    this.lineItems.forEach(item => item.invoicePercent = perc);
    this.recalc();
  }

  onDiscountChanged(perc: number) {
    if (!perc) {
      this.compilation.discount = null;
      perc = null
    }
    this.lineItems.forEach(item => item.discount = perc);
    this.recalc();
  }

  onCurrencyChanged() {
    this.updateAllPrices();
  }

  onObicChanged() {
    if (this.compilation.type === CompilationTypeData.get('OBIC').id) {
      this.compilation.nameOverride = this.compilation.lineItems[0]?.tbCode;
    }
  }

  onPoVisibilityChanged(item: LineItemModel, value: boolean, field: string) {
    if (field === 'poNum' && !value) item.poVisibility = { poNum: false, poPos: false, poDelivery: false };
    if (field === 'poDelivery' && value) item.poVisibility = { poNum: true, poPos: true, poDelivery: true };
    if (field === 'poPos' && value) {
      item.poVisibility.poNum = true;
    } else if (field === 'poPos') {
      item.poVisibility.poDelivery = false;
    }
    item.poVisibility[field] = value;
  }

  getInvoicePercentText() {
    const arr = this.lineItems.map(li => li.invoicePercent);
    if (arr.every(val => val === arr[0])) {
      return `${this.compilation.invoicePercent}% ${InvoicePaymentData.get(this.compilation.invoicePayment).name} `;
    }
    return `${InvoicePaymentData.get(this.compilation.invoicePayment).name} `;
  }

  getLineItemProducts() {
    if (!this.lineItems) return [];
    const baseProducts = this.lineItems.map(li => li.finishedProduct && mongoId(li.finishedProduct.product)).filter(notNull => notNull);
    const current = this.lineItems.map(li => li.finishedProduct && li.finishedProduct._id); // current finished products of line items on top
    const remaining = this.data.finishedProducts.filter(fp =>
      fp
      && baseProducts.includes(mongoId(fp.product))
      && !current.includes(mongoId(fp._id))
    ).map(m => m._id);
    return [...current, ...remaining];
  }

  // getItemOrderPos(item) {
  //   const idx = this.orderLineItems?.findIndex(f => f.position?.internalPos === item.position?.orderPos);
  //   return (idx !== null && idx >= 0) ? idx + 1 : ''; 
  // }

  setItemOrderPos(item: LineItemModel, value: string) {
    const displayPos = new StringToNumberPipe().transform(value);
    const opos = displayPos && this.orderLineItems && this.orderLineItems[displayPos-1];
    const pos = opos && opos.position && opos.position.internalPos >= 0 ? opos.position.internalPos : displayPos-1;
    item.position.orderPos = pos;
    this.calcPartialDelivery();
    setTimeout(() => { // TODO: change detection
      this.hidePopovers();
    }, 200)
  }

  calcPartialDelivery() {
    const ocs = this.tree.getFlatByDocType('OR', this.tree.linkedOR)
      ?.filter(f => f.type === CompilationTypeData.get('OC').id && f.documentStatus !== DocumentStatusData.get('cancelled').id) //filterDocumentTree('OC');
    if (ocs && !ocs.find(f => f.code === this.tree.linkedOC?.code)) ocs.push(this.compilation);  // ?why?
    const sorted = ocs && ocs.sort((a, b) => a.vieDispatchDate > b.vieDispatchDate ? 1 : -1);
    // console.log('calc partial delivery', ocs.map(m => m.code), sorted.map(m => m.code));

    for (const li of this.lineItems) {
      const orPos = li.position && li.position.orderPos;
      let num = 0;
      let sum = 0;
      sorted?.forEach(el => {
        if (el.lineItems.find(f => f.position && f.position.orderPos === orPos)) {
          sum++;
          if (el.code === this.compilation.code) num = sum;
        }
      })
      if (sum > 0) li.partialDelivery = { num, sum }
    }
  }

  getPfspoReportParams(lineItem: LineItemModel) {
    return {
      id: 'OSPO',
      report: 'openspo',
      params: JSON.stringify({
        finishedProducts: [mongoId(lineItem.finishedProduct)],
        sortType: 1,
        dateField: 1,
        dateType: DateSelectionData.all.id,
        dateFrom: null,
        dateTo: null,
      }),
    }
  }

  getOCReportParams(lineItem: LineItemModel) {
    return {
      id: 'NIOC',
      report: 'noninvoiced',
      params: JSON.stringify({
        finishedProducts: [mongoId(lineItem.finishedProduct)],
        sortType: 1,
        dateField: 1,
        dateType: DateSelectionData.all.id,
        dateFrom: null,
        dateTo: null,
      }),
    }
  }

  generateProduct(idx: number) {
    this.showWizard = true;
    this.index = idx;
  }

  async updateFP(item: LineItemModel) {
    const finishedProduct = this.data.finishedProducts.find(f => mongoId(f) === mongoId(item.finishedProduct));
    item.finishedProduct = finishedProduct;
    item.productName = finishedProduct.calcCode + '; ' + finishedProduct.calcName;
    item.hsCode = finishedProduct.hs || undefined;
    item.attributeRemark = finishedProduct.externalName || undefined;
    item.attributeCode = finishedProduct.externalCode || undefined;
    item.publicRemark = finishedProduct.publicRemark || undefined;
    this.recalc();
  }

  updateFinishedProduct(item: LineItemModel = null) {
    this.dialogService.open(CommonDialogComponent, {
      context: {
        dialogType: NrkDialogType.okCancel,
        message: 'This process refreshes following fields: Product name, Customer Product name, Public remark, HS codes. All data entered in the document will be deleted. Pricing and Quantitiy information will not be changed. Are you sure to proceed?'
      }
    }).onClose.subscribe(ret => {
      console.log('ret', ret);
      if (ret?.button === NrkDialogButton.save) {
        if (!item) {
          this.lineItems.forEach((el, idx) => this.updateFP(el));
        } else {
          this.updateFP(item);
        }        
      }
    })
  }

  async onWizardClosed() {
    const boxes = [];
    if (this.infoBoxes && this.infoBoxes.length) {
      this.infoBoxes.forEach(box => boxes.push(box.reloadData()));
      await Promise.all(boxes);
      this.infoBoxes.first.loadSummary();
    }
  }

  // getPositionNumberFormat() {
  //   //console.log('recipient', this.compilation.recipient, this.data.businesses.find(f => mongoId(f) === mongoId(this.compilation.recipient)));
  //   const business = this.data.businesses.find(f => mongoId(f) === mongoId(this.compilation.recipient));
  //   return business.positionNumberFormat || '%02d';
  // }

  // toggleShowLineItemTCinPdf(item: LineItemModel) {
  //   const name = 'liTC' + (item as LineItemModel).position.internalPos;  
  //   if (!item.tcChecked) {
  //     item.tcChecked = true;
  //     if (!this.compilation.visibleFields.includes(name)) this.compilation.visibleFields.push(name);
  //   } else {
  //     item.tcChecked = false;
  //     this.compilation.visibleFields = this.compilation.visibleFields.filter(f => f !== name);
  //   }

  //   console.log('----> toggleShowLineItemTCinPdf', this.compilation.visibleFields);
  // }
  
}


